export interface BenchmarkOperationCounts {
  fitnessEvaluations: number;
  crossoverCalls: number;
  mutationCalls: number;
  localSearchCalls: number;
}

let activeCounts: BenchmarkOperationCounts | null = null;

export function createEmptyBenchmarkOperationCounts(): BenchmarkOperationCounts {
  return {
    fitnessEvaluations: 0,
    crossoverCalls: 0,
    mutationCalls: 0,
    localSearchCalls: 0,
  };
}

export function setActiveBenchmarkOperationCounts(
  counts: BenchmarkOperationCounts | null
): void {
  activeCounts = counts;
}

function increment(
  key: keyof BenchmarkOperationCounts,
  amount: number = 1
): void {
  if (!activeCounts) {
    return;
  }

  activeCounts[key] += amount;
}

export function incrementFitnessEvaluations(amount: number = 1): void {
  increment('fitnessEvaluations', amount);
}

export function incrementCrossoverCalls(amount: number = 1): void {
  increment('crossoverCalls', amount);
}

export function incrementMutationCalls(amount: number = 1): void {
  increment('mutationCalls', amount);
}

export function incrementLocalSearchCalls(amount: number = 1): void {
  increment('localSearchCalls', amount);
}
